import { Component, OnInit, Input, EventEmitter, Output, ViewChild, ElementRef, OnDestroy } from '@angular/core';

export class TotemScreensaverData {
    video?:string
    slides?:Array<{
        image:string,
        text:string
    }>
}

@Component({
    selector: 'app-totem-screensaver',
    templateUrl: './totem-screensaver.component.html',
    styleUrls: ['./totem-screensaver.component.scss'],
    standalone: false
})
export class TotemScreensaverComponent implements OnInit, OnDestroy {

    @Input() playData:TotemScreensaverData;
    @Output() playComplete = new EventEmitter<void>();
    @Output() dismissRequest = new EventEmitter<void>();

    fadeDirection:'in'|'out' = 'in';

    slideIndex = 0;
    private _slideInterval = null;

    availableLanguages = [{
        language: 'en_EN',
        label: 'Touch to start'
    }, {
        language: 'it_IT',
        label: 'Tocca per iniziare'
    }]

    languageIndex = 0;
    isChangingLanguage = false;
    private _languageInterval = null;

    constructor() { }

    @ViewChild('playVideo') playVideo:ElementRef;

    ngOnInit(): void {
        this.fadeDirection = 'in';

        setTimeout(() => {
            this.fadeDirection = null;

            if(this.playData.video != null) {
                if(this.playVideo != null) {
                    let _videoElement = this.playVideo.nativeElement as HTMLVideoElement;

                    _videoElement.onended = () => {
                        this.doPlayComplete();
                    }

                    _videoElement.play();
                }
            }
            else if(this.playData.slides != null) {
                this._slideInterval = setInterval(() => {
                    this.slideIndex++;
                    if(this.slideIndex >= this.playData.slides.length) {
                        this.doPlayComplete();
                    }
                }, 8000)
            }
        }, 1000)

        this._languageInterval = setInterval(() => {
            this.isChangingLanguage = true;

            setTimeout(() => {
                this.languageIndex = (this.languageIndex + 1) % this.availableLanguages.length
                this.isChangingLanguage = false;
            }, 200)
        }, 6000)
    }

    onDismiss(event?: Event) {
        event?.stopPropagation();
        this.dismissRequest.emit();
    }

    doPlayComplete() {
        this.fadeDirection = 'out';
        setTimeout(() => {
            this.playComplete.emit();
        }, 1000)
    }

    ngOnDestroy() {
        clearInterval(this._slideInterval)
        clearInterval(this._languageInterval)
    }
}
